// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2pBEo","emails":"CreateEditClinics_emails__3t8ey","emailTagLabel":"CreateEditClinics_emailTagLabel__2kkzn"};